export default "__VITE_ASSET__DOq_Xul8__"